import { Components } from 'formiojs';
import { OWN_PROVIDER } from '../../package-managment/payment-eligibility';

// Form.io's radio component disables the whole group; this option remains visible
// while the other provider choices stay usable.
export default class PaymentProviderRadio extends Components.components.radio {
  attach(element) {
    const result = super.attach(element);
    this.applyPaymentLock();
    return result;
  }
  set disabled(value) {
    super.disabled = value;
    this.applyPaymentLock();
  }
  get disabled() { return super.disabled; }
  applyPaymentLock() {
    if (!this.component?.ownProviderBlocked) return;
    const inputs = this.refs?.input || [];
    Array.from(inputs).forEach(input => {
      if (input.value === OWN_PROVIDER) { input.disabled = true; input.setAttribute('aria-disabled', 'true'); }
    });
  }
}
